import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IInterviewRequestDoLaterClickedPayload {
  postingId: string;
}

/**
 * Fires when user clicks "Do Later" on the interview request page
 * Event: dental_portal:interview_request:do_later_clicked
 */
export function fireInterviewRequestDoLaterClicked(
  payload: IInterviewRequestDoLaterClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:interview_request:do_later_clicked', {
    posting_id: payload.postingId,
  });
}